module.exports = __webpack_public_path__ + "static/0000-90aa0497445580a27a9a886ff6386def.png";